/**
 * /* eslint-disable no-unused-vars
 *
 * @format
 */

/** @format */

import _, { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
// material
import { Card, CardHeader, Box, Button } from "@mui/material";
//
import { BaseOptionChart } from "../../components/charts";
import moment from "moment";
import React from "react";
import "./style/chart2.css";
import { formatRupiah } from "../../utils/utilitys";

// ----------------------------------------------------------------------

export default function MessagesChart2(props) {
  const { labels, values, cost } = props;
  let dateFormat = "DD MMM YYYY";
  const [chartData, setChartData] = React.useState([]);

  const chartOptions = merge(BaseOptionChart(), {
    stroke: { width: [2, 2, 2] },
    plotOptions: { bar: { columnWidth: "11%", borderRadius: 4 } },
    fill: { type: ["solid", "solid", "solid"] },
    labels: labels,
    xaxis: {
      // type: "datetime",
      categories: labels,
      labels: {
        // format: 'dd MMM HH:mm',
        formatter: function (y) {
          return new moment(y).format(dateFormat);
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box"' +
          "<p>" +
          moment(w.globals.categoryLabels[dataPointIndex]).format(dateFormat) +
          "</p>" +
          `<p style="color: ${w.globals.colors[0]};font-weight: 700;">` +
          "User Initiate  :" +
          w.globals.initialSeries[0]["data"][dataPointIndex] +
          "</p>" +
          `<p style="color: ${w.globals.colors[1]};font-weight: 700;">` +
          "Business Initiate  :" +
          w.globals.initialSeries[1]["data"][dataPointIndex] +
          "</p>" +
          "<p>" +
          "--------------" +
          `<p style="color: ${w.globals.colors[5]};font-weight: 700;">` +
          "Cost User Initiated  :" +
          formatRupiah(
            (
              w.globals.initialSeries[5]["data"][dataPointIndex] *
              cost?.cost_user
            ).toString(),
            "Rp."
          ) +
          "</p>" +
          `<p style="color: ${w.globals.colors[4]};font-weight: 700;">` +
          "Cost Marketing  :" +
          formatRupiah(
            (
              w.globals.initialSeries[4]["data"][dataPointIndex] *
              cost?.cost_business_marketing
            ).toString(),
            "Rp."
          ) +
          "</p>" +
          `<p style="color: ${w.globals.colors[2]};font-weight: 700;">` +
          "Cost Utility  :" +
          formatRupiah(
            (
              w.globals.initialSeries[2]["data"][dataPointIndex] *
              cost?.cost_business_utility
            ).toString(),
            "Rp."
          ) +
          "</p>" +
          `<p style="color: ${w.globals.colors[3]};font-weight: 700;">` +
          "Cost Authentification  :" +
          formatRupiah(
            (
              w.globals.initialSeries[3]["data"][dataPointIndex] *
              cost?.cost_business_authentication
            ).toString(),
            "Rp."
          ) +
          "</p>" +
          "</div>"
        );
      },
    },
    // tooltip: {
    //   shared: true,
    //   intersect: false,
    //   x: {
    //     show: true,
    //     formatter: function (y) {
    //       return new moment(y).format(dateFormat);
    //     },
    //   },
    //   y: {
    //     formatter: (y) => {
    //       if (typeof y !== "undefined") {
    //         return `${y.toFixed(0)}`;
    //       }
    //       return y;
    //     },
    //   },
    //   items: {
    //     display: "flex",
    //   },
    // },
    // tooltip: {
    //   shared: true,
    //   intersect: false,
    //   x: {
    //     show: true,
    //     formatter: function (seriesName) {
    //       return seriesName;
    //     },
    //   },
    //   y: {
    //     formatter: (seriesName) => {
    //       if (typeof y !== "undefined") {
    //         return `${seriesName.toFixed(0)}`;
    //       }
    //       return seriesName;
    //     },
    //   },
    //   items: {
    //     display: "flex",
    //   },
    // },
  });
  // console.log("obj", values);

  React.useEffect(() => {
    const mappData = (values) => {
      let attribute;
      let finalObj = {};
      let finallArr = [];
      if (values.length !== 0) {
        attribute = values[0];
        let arrAttribute = Object.keys(attribute);
        // console.log("arrAttribute", arrAttribute);

        // for(let obj in arrAttribute){

        arrAttribute.forEach((item) => {
          // arrAttribute.forEach((element) => {
          finalObj["name"] = item;
          finalObj["type"] = "line";
          finalObj["data"] = values.map((obj) => obj[item]);
          finallArr.push(finalObj);
          finalObj = {};
          // });
        });
        // }
        setChartData(finallArr);
      }
    };

    let map = true;

    if (map) mappData(values);

    return () => {
      map = false;
    };
  }, [values]);

  // const CHART_DATA = [
  //   {
  //     name: "User",
  //     type: "line",
  //     data: values.map((obj) => obj.user),
  //   },
  //   {
  //     name: "Business",
  //     type: "line",
  //     data: values.map((obj) => obj.business),
  //   },
  // ];

  const downloadData = async () => {
    let unzippedMessagesData = [];
    for (let idx in labels) {
      unzippedMessagesData.push({
        label: labels[idx],
        values: values[idx],
      });
    }
    // console.log(unzippedMessagesData);

    const convertToDate = (param) => {
      let momentDate = moment(param.label);
      momentDate.set({ hour: 10, minute: 0 });
      return momentDate.format("DD MMM YYYY");
    };

    let groupedMessageData = _.groupBy(unzippedMessagesData, convertToDate);
    // console.log(groupedMessageData);

    let resultJSON = [];
    let downloadAttribute = {};
    for (let rawDate of Object.keys(groupedMessageData)) {
      let dayData = groupedMessageData[rawDate];

      for (let datum of dayData) {
        let keyattr = Object.keys(datum.values);
        for (let datum2 of keyattr) {
          downloadAttribute[datum2] = datum.values[datum2];
        }
      }
      resultJSON.push({
        date: rawDate,
        ...downloadAttribute,
      });
    }

    let dataHeader = Object.keys(downloadAttribute)
      .map((item) => item)
      .join(";");
    let header = `date;` + dataHeader;
    let body = "";
    for (let rj of resultJSON) {
      body += `\n${rj.date};${rj.user};${rj.business};${formatRupiah(
        (rj["cost business utility"] * cost?.cost_business_utility).toString(),
        "Rp."
      )};${formatRupiah(
        (
          rj["cost business authentication"] *
          cost?.cost_business_authentication
        ).toString(),
        "Rp."
      )};${formatRupiah(
        (
          rj["cost business marketing"] * cost?.cost_business_marketing
        ).toString(),
        "Rp."
      )};${formatRupiah(
        (rj["cost user initiated"] * cost?.cost_user).toString(),
        "Rp."
      )}`;
    }

    let csvText = header + body;

    const element = document.createElement("a");
    const file = new Blob([csvText], { type: "text/csv;charset=utf-8" });
    element.href = URL.createObjectURL(file);
    element.download = "conversation_data_export.csv";
    document.body.appendChild(element);
    element.click();
  };

  return (
    <Card>
      <CardHeader title="Conversation" />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          paddingRight: 20,
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            downloadData();
          }}
        >
          Download
        </Button>
      </div>
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart
          type="line"
          series={chartData}
          options={chartOptions}
          height={364}
        />
      </Box>
    </Card>
  );
}
